import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {provideRouter, withInMemoryScrolling, withViewTransitions} from '@angular/router';
import {provideClientHydration, withHttpTransferCacheOptions} from '@angular/platform-browser';
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';
import {TranslateModule} from '@ngx-translate/core';

import {routes} from './app.routes';
import {apiInterceptor} from './theme/admin/interceptors/api.interceptor';
import {loaderInterceptor} from './theme/admin/interceptors/loader.interceptor';
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {LoaderService} from "./theme/admin/services/loader.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        apiInterceptor,
        loaderInterceptor(new LoaderService),
      ]),
    ),
    importProvidersFrom(
      TranslateModule.forRoot(),
    ),
  ],
};
